import { useParams, useSearchParams } from 'next/navigation'
import { useMemo } from 'react'

export const useUrlParam = (key: string, urlType: 'search' | 'path') => {
    const searchParams = useSearchParams()
    const pathParams = useParams()

    return useMemo(() => {
        const rawCurrentUrlValue =
            (urlType === 'search' ? searchParams.get(key) : (pathParams[key] as string)) ??
            undefined

        if (!rawCurrentUrlValue) return undefined

        return decodeURIComponent(rawCurrentUrlValue)
    }, [key, pathParams, searchParams, urlType])
}
